import { IBlock } from "../../../framework/src/IBlock";
import { Message } from "../../../framework/src/Message";
import { BlockComponent } from "../../../framework/src/BlockComponent";
import MessageEnum, {
  getName,
} from "../../../framework/src/Messages/MessageEnum";
import { runEngine } from "../../../framework/src/RunEngine";

// Customizable Area Start
import { makeApiMessage } from "../../../components/src/common";
import { IScheduleItem } from "./ReportSchedulerController";

export const configJSON = require("./config");
// Customizable Area End

export interface Props {
  navigation: {
    navigate: Function;
    getParam: Function;
  };
  id: string;
  // Customizable Area Start
  // Customizable Area End
}

export interface S {
  // Customizable Area Start
  scheduleData: IScheduleItem | null;
  isLoading: boolean;
  // Customizable Area End
}

interface SS {
  id: any;
  // Customizable Area Start
  // Customizable Area End
}

export default class ReportSchedulerViewController extends BlockComponent<
  Props,
  S,
  SS
> {
  // Customizable Area Start
  getScheduleApiCallId: string = "";
  // Customizable Area End

  constructor(props: Props) {
    super(props);
    this.receive = this.receive.bind(this);

    // Customizable Area Start
    this.subScribedMessages = [
      getName(MessageEnum.AccoutLoginSuccess),
      getName(MessageEnum.RestAPIResponceMessage),
      getName(MessageEnum.RestAPIResponceSuccessMessage),
      getName(MessageEnum.RestAPIResponceDataMessage),
    ];

    this.state = {
      scheduleData: null,
      isLoading: false,
    };
    runEngine.attachBuildingBlock(this as IBlock, this.subScribedMessages);

    // Customizable Area End
  }

  async receive(from: string, message: Message) {
    runEngine.debugLog("Message Received", message);

    // Customizable Area Start
    const requestId = message.getData(
      getName(MessageEnum.RestAPIResponceDataMessage)
    );

    const successResponse = message.getData(
      getName(MessageEnum.RestAPIResponceSuccessMessage)
    );

    if (successResponse) {
      if (requestId === this.getScheduleApiCallId) {
        this.handleGetScheduleResponse(successResponse);
      }
    }
    // Customizable Area End
  }

  // Customizable Area Start
  async componentDidMount() {
    super.componentDidMount();
    this.getScheduleDetails();
  }

  getScheduleDetails = () => {
    this.setState({ isLoading: true });
    const id = this.props.navigation.getParam("id");

    const requestMessage = makeApiMessage({
      url: `bx_block_reportscheduler/report_schedules/${id}`,
      method: "GET",
    });

    this.getScheduleApiCallId = requestMessage.messageId;
    runEngine.sendMessage(requestMessage.id, requestMessage);
  };

  handleGetScheduleResponse = (responseJson: { data?: IScheduleItem }) => {
    this.setState({ isLoading: false });

    if (responseJson && responseJson.data) {
      this.setState({ scheduleData: responseJson.data });
    }
  };

  handleBack = () => {
    this.props.navigation.navigate("ReportScheduler");
  };
  // Customizable Area End
}
